module.exports = __webpack_public_path__ + "static/media/ethereum-logo.5fc4cc53.png";